import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown } from "react-bootstrap";
import { SolidButton } from "../../../library/button";
import {
  changePipelineModal,
  retrieveSinglePipelineDetails,
  setActiveEditPipeline,
} from "../../../../redux/actions/pipeline";
import DropdownMenu from "../../../universal/dropdown-menu";
import "./style.scss";
import { Title } from "../../../library/title";

const Index = () => {
  const dispatch = useDispatch();

  const selectedCompany = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany
  );
  const activePipeline = useSelector((state) => state.pipeline.activePipeline);

  const allPipelines = useSelector((state) => state.pipeline.selections);
  const fetchAllPipelinesLoading = useSelector(
    (state) => state.pipeline.fetchAllPipelines.loading
  );
  const fetchSinglePipelineLoading = useSelector(
    (state) => state.pipeline.fetchSinglePipeline.loading
  );
  const units = useSelector(
    (state) =>
      state.pipeline.activePipeline && state.pipeline.activePipeline.units
  );

  const [pipelineDropdownOpen, setPipelineDropdownOpen] = useState(false);

  const clickSetingsButton = () => {
    if (
      selectedCompany?.id &&
      selectedCompany.subscription &&
      activePipeline.id
    ) {
      dispatch(changePipelineModal({ editPipelineModal: true }));
      dispatch(
        setActiveEditPipeline({
          companyId: selectedCompany,
          units: units,
          id: activePipeline.id,
          name: activePipeline.name,
        })
      );
    }
  };

  const renderButtonDisplay = () => {
    if (activePipeline.id && selectedCompany.id && !fetchAllPipelinesLoading) {
      return activePipeline.name;
    }

    return "Laster";
  };

  const selectSinglePipeline = (id) => {
    dispatch(
      retrieveSinglePipelineDetails({
        companyId: selectedCompany.id,
        pipelineId: id,
      })
    );
  };

  const clickAddNewPipeline = () => {
    if (selectedCompany && selectedCompany.subscription) {
      dispatch(changePipelineModal({ newPipelineModal: true }));
    }
  };

  const determineNewOpportunityButtonTitle = () => {
    if (!selectedCompany) {
      return "new-opportunity-button disabled";
    }

    if (!selectedCompany.subscription && !selectedCompany) {
      return "new-opportunity-button disabled";
    }

    if (!activePipeline) {
      return "new-opportunity-button disabled";
    }

    return "new-opportunity-button";
  };

  const determineNewOpportunityClick = () => {
    if (selectedCompany && activePipeline && !fetchAllPipelinesLoading) {
      dispatch(changePipelineModal({ addUnitPipelineModal: true }));
    }
  };

  const renderToggle = () => {
    return (
      <Dropdown.Toggle
        onClick={() => setPipelineDropdownOpen(!pipelineDropdownOpen)}
        disabled={fetchAllPipelinesLoading ? true : false}
        id="dropdown-filter"
      >
        {renderButtonDisplay()} <i class="fad arrow fa-angle-down"></i>
      </Dropdown.Toggle>
    );
  };

  const selectOptions = (pipelines) => {
    const result = [];
    if (
      !fetchAllPipelinesLoading &&
      !fetchSinglePipelineLoading &&
      allPipelines &&
      allPipelines.length > 0
    ) {
      for (var pipeline in allPipelines) {
        const id = allPipelines[pipeline].id;
        const item = {
          title: allPipelines[pipeline].name,
          key: id,
          active: activePipeline.id === id,
          action: () => selectSinglePipeline(id),
        };
        result.push(item);
      }
    }

    result.push(
      {
        title: "separator",
        key: "separator",
      },
      {
        title: "Ny pipeline",
        key: "new",
        active: null,
        action: () => clickAddNewPipeline(),
      }
    );

    return result;
  };

  return (
    <section className="dashboard-pipeline-upper-row-section">
      <Row className="upper-row">
        <Col className="text-left title-col my-auto">
          <Col className="inner-title-col">
            <Title size="regular">Pipeline</Title>
          </Col>
        </Col>
        <Col className="text-right button-col my-auto">
          <Col className="inner-button-col">
            <SolidButton
              disabled={activePipeline.id ? false : true}
              onClick={() => clickSetingsButton()}
              icon={<i className="fas fa-cog"></i>}
              color="gray"
              spacing="right"
              title="Innstillinger"
            />
            <DropdownMenu
              content="regular"
              type="title"
              color="inverse-blue"
              spacing="right"
              size="regular"
              toggle={renderToggle()}
              title="Velg pipeline"
              options={selectOptions(allPipelines)}
              open={pipelineDropdownOpen}
              setOpen={setPipelineDropdownOpen}
            />
            <SolidButton
              color="blue"
              icon={<i class="fad fa-plus"></i>}
              title="Ny mulighet"
              onClick={() => determineNewOpportunityClick()}
              className={determineNewOpportunityButtonTitle()}
            />
          </Col>
        </Col>
      </Row>
    </section>
  );
};

export default Index;
